import { useQuery } from "@tanstack/react-query";
import { useCompanyAxis } from "@/api/use-company-context";
import { useSessionScope } from "@/auth/use-session-scope";
import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope } from "@/api/errors";
export const canOpenExpenseManagement = (value: { can_manage: boolean } | undefined): boolean => value?.can_manage === true;
export function useExpenseAccess({ enabled = true }: { enabled?: boolean } = {}) {
  const scope = useSessionScope(); const company = useCompanyAxis();
  return useQuery({ queryKey: ["expenses", ...scope, "capabilities", company.active_legal_entity_id], queryFn: () => unwrapEnvelope(platformGraph.GET("/v1/expenses/capabilities")), enabled, staleTime: 30_000 });
}
